module.exports = __webpack_public_path__ + "static/media/Texas_manufacturing_business_guide_wbn_b2b_export_suppliers.f8c7dd7f.svg";